export default __webpack_public_path__ + "static/media/bash.7c880528.png";